import { render, staticRenderFns } from "./CurrentZgbTeamMembersList.vue?vue&type=template&id=6d7c9330"
import script from "./CurrentZgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./CurrentZgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./CurrentZgbTeamMembersList.vue?vue&type=style&index=0&id=6d7c9330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports